export const settings = [
  {
    path: `/Settings`,
    name: `Settings`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: 'index',
        name: 'Settings/index',
        component: () => import('@/views/person/Config.vue')
      }
    ]
  }
];
